/**
 * Checks if a value is a variation of "other" answer option.
 * Handles case sensitivity and variations like "Other:", "other", "Other (lowercase):", etc.
 * 
 * @param value - The value to check
 * @returns true if the value is a variation of "other"
 */
export const isOtherValue = (value: string | undefined | null): boolean => {
  if (!value) return false;
  
  // Normalize the value:
  // 1. Convert to lowercase
  // 2. Remove trailing colons
  // 3. Remove parenthetical text like "(lowercase)" or "(capitalized)"
  // 4. Trim whitespace
  const normalized = value
    .toLowerCase()
    .replace(/\([^)]*\)/g, '') // Remove text in parentheses
    .replace(/:+$/, '')         // Remove trailing colons
    .trim();
  
  return normalized === 'other';
};

